module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.devisForm) ? _c('cm-attachments-devis-form', {
    attrs: {
      "devisFormData": _vm.devisFormData
    },
    on: {
      "close": function($event) {
        _vm.devisForm = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.paymentAxepta) ? _c('cm-payment-axepta', {
    attrs: {
      "paymentDetails": _vm.paymentDetails
    },
    on: {
      "close": function($event) {
        _vm.paymentAxepta = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.bankAccountQRCode) ? _c('bank-account-qr-code', {
    attrs: {
      "accountId": _vm.accountId
    },
    on: {
      "close": function($event) {
        _vm.bankAccountQRCode = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.scannerQRCode) ? _c('scanner-qr-code', {
    attrs: {
      "content": _vm.scannerQRCodeContent
    },
    on: {
      "close": function($event) {
        _vm.scannerQRCode = false
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('cm-service-popups'), _vm._v(" "), _c('cm-service-switcher-popup', {
    attrs: {
      "closeButton": true
    }
  }), _vm._v(" "), _c('cm-switch-profile', {
    attrs: {
      "closeButton": true
    }
  }), _vm._v(" "), _c('cm-user-reset-password', {
    attrs: {
      "closeButton": true
    }
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-f6325ee6", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f6325ee6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/popups/Popups.vue
// module id = 2528
// module chunks = 2